export function formatSalary(value) {

  if (
    value === undefined ||
    value === null ||
    value === ''
  ) {
    return '';
  }

  const numericValue = Number(
    String(value).replace(/[^0-9.-]/g, '')
  );

  if (isNaN(numericValue)) {
    return value;
  }

  return numericValue.toLocaleString(
    'en-CA',
    {
      style: 'currency',
      currency: 'CAD',
      maximumFractionDigits: 0
    }
  );
}